export class ControlDialogOptionsHelper {
  public labelTitle = 'Libellé';
  public placeholderTitle = 'Aide à la saisie du champ';
  public tooltipTitle = 'Info bulle';
  public labelText = 'Libellé du champ à afficher';
  public placeholderText = 'Saisir l\'aide à la saisie';
  public tooltipText = 'Saisir l\'info bulle';
}
